import { createSlice } from "@reduxjs/toolkit";
import { getOrgFormsThunk, getOrgFormFieldsThunk, createFormThunk, addFormResponseThunk } from "./formsThunk";

const initialState = {
    status: "idle",
    error: null,
    success: "",
    organizatiomForms: [],
    formFieldTypes: [],
};

const organizatiomFormSlice = createSlice({
    name: "organizatiomForm",
    initialState,
    reducers: {
        resetOrgFromState: (state, action) => {
            state.status = "idle";
            state.error = null;
            state.success = "";
            state.organizatiomForms = [];
            state.formFieldTypes = [];
        }
    },
    extraReducers: (builder) => {
        builder
            // ORGANIZATION FORMS
            .addCase(getOrgFormsThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getOrgFormsThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.organizatiomForms = action.payload;
            })
            .addCase(getOrgFormsThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Forms failed";
                state.success = "";
            })


            // ORGANIZATION FORM FIELDS
            .addCase(getOrgFormFieldsThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getOrgFormFieldsThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.formFieldTypes = action.payload;
            })
            .addCase(getOrgFormFieldsThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Forms failed";
                state.success = "";
            })


            // CREATE ORGANIZATION FORM
            .addCase(createFormThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(createFormThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(createFormThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "form creation failed";
                state.success = "";
            })


            // ADD FORM RESPONSE
            .addCase(addFormResponseThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(addFormResponseThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(addFormResponseThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "form creation failed";
                state.success = "";
            })
    },
});

export const { resetOrgFromState } = organizatiomFormSlice.actions;
export default organizatiomFormSlice.reducer;